import React from 'react';
import { Typography } from '@mui/material';
import Layout from './components/Layout';
import Login from './components/Login';
import Register from './components/Register';
import CampusList from './components/CampusList';
import Dashboard from './components/Dashboard'; // Import the new Dashboard component
import LecturerManagement from './components/LecturerManagement'; // Import LecturerManagement
import CourseManagement from './components/CourseManagement'; // Import CourseManagement
import UnitManagement from './components/UnitManagement'; // Import UnitManagement
import UnitCostManagement from './components/UnitCostManagement'; // Import UnitCostManagement
import CourseTracking from './components/CourseTracking'; // Import CourseTracking
import StudentManagement from './components/StudentManagement'; // Import StudentManagement
import AssignedLecturersReport from './components/AssignedLecturersReport'; // Import the new component
import MpesaCredentialManagement from './components/MpesaCredentialManagement'; // Import MpesaCredentialManagement
import AttendanceReports from './components/AttendanceReports'; // Import AttendanceReports
import PaymentReports from './components/PaymentReports'; // Import PaymentReports
import AnalyticsDashboard from './components/AnalyticsDashboard'; // Import AnalyticsDashboard
import SubscriptionManagement from './components/SubscriptionManagement'; // Import SubscriptionManagement
import Settings from './components/Settings'; // Import Settings
import CourseDetailsPage from './components/CourseDetailsPage';
import EarningsManagement from './components/EarningsManagement';

import CertificationManagement from './components/CertificationManagement';
import StudentProgressTracking from './components/StudentProgressTracking';
import UserManagement from './components/UserManagement';
import SuperAdminDashboard from './components/super-admin/SuperAdminDashboard';
import InstitutionManagement from './components/super-admin/InstitutionManagement';
import InstitutionDetails from './components/super-admin/InstitutionDetails';
import BillingLedger from './components/super-admin/BillingLedger';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
  React.useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    document.body.style.fontFamily = "'Inter', sans-serif";
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/campuses" element={
            <ProtectedRoute>
              <Layout><CampusList /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/lecturers" element={
            <ProtectedRoute>
              <Layout><LecturerManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/students" element={
            <ProtectedRoute>
              <Layout><StudentManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/courses" element={
            <ProtectedRoute>
              <Layout><CourseManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/units" element={
            <ProtectedRoute>
              <Layout><UnitManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/unit-costs" element={
            <ProtectedRoute>
              <Layout><UnitCostManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/course-tracking" element={
            <ProtectedRoute>
              <Layout><CourseTracking /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/assigned-lecturers-report" element={
            <ProtectedRoute>
              <Layout><AssignedLecturersReport /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/mpesa-credentials" element={
            <ProtectedRoute>
              <Layout><MpesaCredentialManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/payments" element={
            <ProtectedRoute>
              <Layout><PaymentReports /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/attendance" element={
            <ProtectedRoute>
              <Layout><AttendanceReports /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Layout><AnalyticsDashboard /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/subscription" element={
            <ProtectedRoute>
              <Layout><SubscriptionManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/earnings" element={
            <ProtectedRoute>
              <Layout><EarningsManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <Layout><Settings /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/course-details/:courseId" element={
            <ProtectedRoute>
              <Layout><CourseDetailsPage /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/certification-management" element={
            <ProtectedRoute>
              <Layout><CertificationManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/student-progress/:studentId" element={
            <ProtectedRoute>
              <Layout><StudentProgressTracking /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute>
              <Layout><UserManagement /></Layout>
            </ProtectedRoute>
          } />

          {/* Super Admin Routes */}
          <Route path="/super-admin" element={
            <ProtectedRoute role="super_admin">
              <Layout><SuperAdminDashboard /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/super-admin/institutions" element={
            <ProtectedRoute role="super_admin">
              <Layout><InstitutionManagement /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/super-admin/institutions/:id" element={
            <ProtectedRoute role="super_admin">
              <Layout><InstitutionDetails /></Layout>
            </ProtectedRoute>
          } />
          <Route path="/super-admin/billing" element={
            <ProtectedRoute role="super_admin">
              <Layout><BillingLedger /></Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
